// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jzon from "rescript-jzon/lib/es6/src/Jzon.res.js";
import * as LumiJzon from "lumi-rescript/lib/es6/src/LumiJzon.res.js";
import * as StringCodec from "lumi-rescript/lib/es6/src/StringCodec.res.js";
import * as FontAwesome$Web from "lumi-web/lib/es6/src/FontAwesome.res.js";
import * as LumiGeolocation from "lumi-rescript/lib/es6/src/LumiGeolocation.res.js";
import * as Schema$LumiStore from "lumi-store/lib/es6/src/Schema.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Types$LumiDocuments from "./Types.res.js";
import * as TrainingDataSpec$LumiDocuments from "./TrainingDataSpec.res.js";

let options = [
  "Planned",
  "Operational",
  "Archived"
];

let stringCodec = StringCodec.anySumAsString(options, undefined);

let jsonCodec = LumiJzon.stringCodec(stringCodec);

function FacilityServer$ServerOperationalState(props) {
  let value = props.value;
  let tmp;
  switch (value) {
    case "Planned" :
      tmp = JsxRuntime.jsx("span", {
        children: JsxRuntime.jsx(FontAwesome$Web.Solid.make, {
          name: "person-digging"
        }),
        className: "icon has-text-warning"
      });
      break;
    case "Operational" :
      tmp = JsxRuntime.jsx("span", {
        children: JsxRuntime.jsx(FontAwesome$Web.Solid.make, {
          name: "gears"
        }),
        className: "icon has-text-success"
      });
      break;
    case "Archived" :
      tmp = JsxRuntime.jsx("span", {
        children: JsxRuntime.jsx(FontAwesome$Web.Solid.make, {
          name: "broom"
        }),
        className: "icon has-text-grey-light"
      });
      break;
  }
  return JsxRuntime.jsxs("span", {
    children: [
      tmp,
      JsxRuntime.jsx("span", {
        children: stringCodec.toString(value)
      })
    ],
    className: "icon-text"
  });
}

let ServerOperationalState = {
  options: options,
  stringCodec: stringCodec,
  jsonCodec: jsonCodec,
  make: FacilityServer$ServerOperationalState
};

let jsonCodec$1 = Jzon.object6(param => [
  param.baseUrl,
  param.notes,
  param.location,
  param.geoLocation,
  param.operationalState,
  param.trainingDataSpec
], param => ({
  TAG: "Ok",
  _0: {
    baseUrl: param[0],
    notes: param[1],
    location: param[2],
    geoLocation: param[3],
    operationalState: param[4],
    trainingDataSpec: param[5]
  }
}), Jzon.field("baseUrl", Types$LumiDocuments.BaseUrl.jsonCodec), Jzon.field("notes", Jzon.string), Jzon.field("location", Jzon.string), Jzon.field("geoLocation", LumiGeolocation.jsonCodec), Jzon.field("operationalState", jsonCodec), Jzon.field("trainingDataSpec", Jzon.nullable(TrainingDataSpec$LumiDocuments.TrainingDataSpec.jsonCodec)));

let FacilityServer = {
  jsonCodec: jsonCodec$1
};

function documentName(param) {
  return param.baseUrl.host;
}

let Schema = Schema$LumiStore.Make({
  documentName: documentName,
  tag: "facility-server",
  jsonCodec: jsonCodec$1,
  icon: "server",
  readOnly: false
});

export {
  ServerOperationalState,
  FacilityServer,
  Schema,
}
/* stringCodec Not a pure module */
